import { MainView, SideView, Wrapper } from './main-admin-page.styles';
import { MAIN_VIEW_BY_ROLE, SIDE_VIEW_BY_ROLE } from '../config/ui-constant';
import { useCurrentUserSelector } from '../../../entities/current-user/model/selectors';
import { getCurrentUserRole } from '@shared/lib/utils/get-current-user-role/get-current-user-role';

export const MainAdminPage = () => {
    const user = useCurrentUserSelector();
    const role = getCurrentUserRole(user);

    if (!role) {
        return null;
    }

    return (
        <Wrapper>
            <MainView>{MAIN_VIEW_BY_ROLE[role]}</MainView>
            <SideView>{SIDE_VIEW_BY_ROLE[role]}</SideView>
        </Wrapper>
    );
};
